// src/tools/drawing/markerTool.js

/**
 * Инструмент для создания точечных объектов (меток).
 * Работает через useDrawingTools.
 */
export const markerTool = {
  _startDrawing: null, // Функция для начала рисования из useDrawingTools
  _stopDrawing: null,  // Функция для остановки рисования из useDrawingTools

  initialize: (map, options) => {
    console.log('Marker tool initialized');
    if (options?.drawingControls) {
      markerTool._startDrawing = options.drawingControls.startDrawing;
      markerTool._stopDrawing = options.drawingControls.stopDrawing;
    }
  },
  activate: (type, defaultProperties) => {
    console.log('Marker tool activated');
    markerTool._startDrawing?.('point', defaultProperties, false);
  },
  deactivate: () => {
    console.log('Marker tool deactivated');
    markerTool._stopDrawing?.();
  },
  cleanup: () => {},
};